import { z } from 'zod';
export var MyStoryMyPlanStep = z.enum([
    'OVERVIEW',
    'MYSTORY__INTRODUCTION',
    'MYSTORY__TIMELINE',
    'MYSTORY__TIMELINE_REVIEW',
    'MYSTORY__TIMELINE_FINAL',
    'RISK_CURVE__INTRODUCTION',
    'RISK_CURVE__REVIEW',
    'MY_PLAN__INTRODUCTION',
    'MY_PLAN__REVIEW',
    'COMPLETE'
]);
export var CurrentEditorEnum = z.enum([
    'CLINICIAN',
    'PATIENT__SOCIAL_CONTACT_PICKER',
    'PATIENT__SOCIAL_PLACE_PICKER',
    'PATIENT__HELP_CONTACT_PICKER',
    'PATIENT__PROFESSIONAL_CONTACT_PICKER',
    'PATIENT__SUPPORT_CONTACT_PICKER'
]);
export var MyStoryMyPlanState = z.object({
    currentStep: MyStoryMyPlanStep.prefault('OVERVIEW'),
    currentEditor: CurrentEditorEnum.prefault('CLINICIAN')
}).prefault({
    currentStep: 'OVERVIEW',
    currentEditor: 'CLINICIAN'
});
